module.exports = __webpack_public_path__ + "static/media/storage_hero_image.8ada6a70.png";